<template>
  <!-- 根据是否显示行业专区更换皮肤 -->
  <div class="search-bar" :class="{ 'search-bar-industry-zone': isShowIndustryZone }">
    <!-- id=search_input 是给新手任务遮罩使用的 -->
    <div class="search_input_container" id="search_input">
      <!-- 输入框左侧 -->
      <div
        class="search_input_container_left"
        @mouseenter="handleClassifyMouseOver('enter')"
        @mouseleave="handleClassifyMouseOver('leave')"
      >
        <!-- 搜索分类 -->
        <!-- isNew tag -->
        <img
          v-if="currentClassifyCategory.find((v) => v.id === filterModeLocal).isNew"
          class="icon_new"
          src="../../../assets/img/SearchBar/icon_new.png"
          alt="icon_new"
        />
        {{ currentClassifyCategory.find((v) => v.id === filterModeLocal).text }}
        <!-- 上下箭头 -->
        <i class="iconfont icon-arrow-down-sm" :class="isShowPopupSearchClassify ? 'rotate' : ''" />
        <!-- 下拉弹窗 搜索分类集合 -->
        <PopupSearchClassify
          @mouseenter="handleClassifyMouseOver('enter')"
          @mouseleave="handleClassifyMouseOver('leave')"
          :open="isShowPopupSearchClassify"
          @cell="handleClassifySelect"
        />
      </div>
      <!-- 输入框中间 -->
      <div
        class="search_input_container_center"
        @mouseenter="handleInputMouseOver('enter')"
        @mouseleave="handleInputMouseOver('leave')"
      >
        <!-- 输入框 -->
        <input
          type="text"
          v-model.trim="keywordsLocal"
          placeholder="请输入您要搜索的内容"
          @keydown.enter="search"
          maxlength="100"
          ref="input"
          @focus="isInputFocused = true"
          @blur="isInputFocused = false"
          @keydown.esc="
            () => {
              isShowPopupSearchHistory = false;
              isShowPopupPopularSearch = false;
            }
          "
        />
        <!-- 清空按钮 -->
        <i v-show="keywordsLocal" class="iconfont icon-shanchux" @click="handleSearchInputClear"></i>
        <!-- 下拉弹窗 历史记录 -->
        <PopupSearchHistory
          @mouseenter="handleHistoryMouseOver('enter')"
          @mouseleave="handleHistoryMouseOver('leave')"
          :open="!!searchHistory.length && isShowPopupSearchHistory"
          @cell="handleHistorySelect"
          @delete="handleHistoryDelete"
          @clear="handleHistoryClear"
        />
        <!-- 下拉弹窗 热搜 -->
        <PopupPopularSearch
          :open="isShowPopupPopularSearch"
          @popular="handlePopularSelect"
          @company="handleCompanySelect"
          :keywords-local="keywordsLocal"
          @fetched="handlePopularAndCompanyFetched"
          @more="handleMoreCompanyClick"
        />
      </div>
      <!-- 输入框右侧 -->
      <div class="search_input_container_right" @click="handleSearchClick">
        <!-- 搜索按钮 -->
        <i class="iconfont icon-search"></i>
      </div>
    </div>

    <!-- 拓展搜索词 -->
    <div v-if="expandSearchKeywords.length" class="expand_key_words">
      <el-checkbox class="checkbox" v-model="isExpandSearchKeywordsChecked">拓展搜索： </el-checkbox>
      <div class="words_container">
        <span class="words" :key="key" v-for="(text, key) in expandSearchKeywords">
          {{ text }}
        </span>
      </div>
    </div>

    <!-- 相关搜索 -->
    <div v-else class="related_key_words">
      <template v-if="relatedSearchOnShow.length">
        <span class="title">相关搜索：</span>
        <div class="words_container">
          <span
            @click="handleRelatedSearchClick(text)"
            class="words"
            :key="key"
            v-for="(text, key) in relatedSearchOnShow"
          >
            {{ text }}
          </span>
        </div>
        <div class="refresh" @click="handleRefreshClick">
          <i class="iconfont icon-huanyipi" style="font-size: 10px"></i>
        </div>
      </template>
      <div class="default_related_search" v-else>
        <span
          @click="handleRelatedSearchClick(text)"
          class="words"
          :key="key"
          v-for="(text, key) in DEFAULT_RELATED_SEARCH"
        >
          {{ text }}
        </span>
        <div class="tips">
          <div class="scroll">
            {{ DEFAULT_RELATED_SEARCH_TIPS }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { websiteKeywordSearchV3 } from "@/services/common/search";
import { restAccountIndustryGetBusinessCount, restAccountIndustryQueryIsEnter } from "@/services/common/industry-zone";
import PopupSearchClassify from "./PopupSearchClassify";
import PopupSearchHistory from "./PopupSearchHistory";
import PopupPopularSearch from "./PopupPopularSearch";
import {
  CLASSIFY_A,
  DEFAULT_RELATED_SEARCH,
  DEFAULT_RELATED_SEARCH_TIPS,
  LOCAL_STORAGE_KEY_MAP,
  MORE_COMPANY_URL,
  TIME_LIST, // todo 新大搜上线后删除
  TYPE_ALL, // todo 新大搜上线后删除
} from "@/utils/constants/constants";
import {
  authCheck,
  deepClone,
  getQuery, // todo 新大搜上线后删除
} from "@/utils/common";
import { CookieKeys, Cookies } from "@/utils/cookieKey";
import { FILTER_TABS } from "@/utils/constants/constants.search";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";
import { AUTH_KEY_MAP } from "@/utils/constants/constants.auth";
import _ from "lodash";
import { USER_CENTER_SEARCH_URL } from "@/utils/constants/constants.menu";
import { getAreaJson } from "@/assets/areaJSON"; // todo 新大搜上线后删除
import { DICTIONARY } from "@/utils/constants/constants.dictionary"; // todo 新大搜上线后删除

const debounce = _.debounce((params, func) => {
  func(params);
}, 200);

export default {
  name: "SearchBar",
  data() {
    return {
      DEFAULT_RELATED_SEARCH,
      DEFAULT_RELATED_SEARCH_TIPS,
      relatedSearchRound: 0,
      relatedSearchOnShow: [],
      isShowPopupSearchClassify: false, // 分类集合
      isShowPopupSearchHistory: false, // 搜索历史
      isShowPopupPopularSearch: false, // 热搜
      keywordsLocal: "",
      filterModeLocal: CLASSIFY_A[0].id,
      tabIdLocal: FILTER_TABS[0].id,
      isInputFocused: false,
      // 拓展搜索词
      expandSearchKeywords: [],
      isExpandSearchKeywordsChecked: true,
      // 相关热搜
      relatedPopularSearch: [],
      // 相关公司
      relatedCompanies: [],
      // todo 新大搜上线后删除
      eventListenerAdded: false,
    };
  },
  components: {
    PopupSearchClassify, // 分类集合
    PopupSearchHistory, // 搜索历史
    PopupPopularSearch, // 热搜
  },
  computed: {
    currentClassifyCategory() {
      return this.$store.getters["search/currentClassifyCategory"];
    },
    currentFilterTab() {
      return this.$store.getters["search/currentFilterTab"];
    },
    relatedSearch() {
      return this.$store.getters["search/relatedSearch"];
    },
    searchHistory() {
      return this.$store.getters["search/searchHistory"];
    },
    isShowIndustryZone() {
      return this.$store.getters["industryZone/isShowIndustryZone"];
    },
    industryZoneData() {
      return this.$store.getters["industryZone/industryZoneData"];
    },
    expandSearchKeywordsPackages() {
      return this.$store.getters["search/expandSearchKeywordsPackages"];
    },
    updateSearchParamsConditions() {
      return {
        keywords: this.$route.query.keywords,
        filtermode: this.$route.query.filtermode,
        tabId: this.$route.query.tabId,
        _t: this.$route.query._t,
        currentFilterTab: this.$store.getters["search/currentFilterTab"], // 大搜条件区域的tab 综合 招标 拟建等
      };
    },
    setSearchHistoryConditions() {
      return {
        searchParams: this.$store.getters["search/searchParams"],
        searchChoseParams: this.$store.getters["search/searchChoseParams"],
      };
    },
  },
  watch: {
    // 路由query变更会触发updateSearchParams
    updateSearchParamsConditions: {
      handler(newV, oldV) {
        if (JSON.stringify(newV) !== JSON.stringify(oldV)) {
          this.updateSearchParamsAndMore();
        }
      },
      immediate: true,
      deep: true,
    },
    // searchParams变更会触发设置searchHistory
    setSearchHistoryConditions: {
      handler(setSearchHistoryConditions) {
        const { searchParams, searchChoseParams } = setSearchHistoryConditions;
        // 配置搜索历史
        this.setSearchHistory(searchParams, searchChoseParams);
      },
      deep: true,
    },
    relatedSearch(newV) {
      this.relatedSearchOnShow = newV.slice(0, 6);
      this.$track(DEED_MAP.EXPOSURE, OID_MAP.RELATED_SEARCH_EXPOSURE, {
        extendinfo: this.keywordsLocal,
      });
    },
    relatedSearchRound(newV) {
      this.relatedSearchOnShow = this.relatedSearch.slice(newV * 6, newV * 6 + 6);
    },
    isInputFocused(focused) {
      // 空数据，不再弹窗
      // 且无数据时触发关闭弹窗的操作
      // 在handlePopularAndCompanyFetched完成
      if (this.relatedPopularSearch.length === 0 && this.relatedCompanies.length === 0) {
        return;
      }
      // 如果聚焦且存在关键词，展示热搜，否则相反。
      // 搜索历史不通过focus判断，因为删除历史时，会意外导致关闭弹窗
      if (focused) {
        this.isShowPopupPopularSearch = !!this.keywordsLocal;
        // this.isShowPopupSearchHistory = !!!this.keywordsLocal;
      }
      if (!focused) {
        setTimeout(() => {
          // 直接通过blur关闭弹窗会导致click失效，故延时
          this.isShowPopupPopularSearch = false;
          // this.isShowPopupSearchHistory = false;
        }, 300);
      }
    },
    // 历史弹窗展开时，获取历史记录
    isShowPopupSearchHistory(newV) {
      if (newV) {
        this.readingSearchHistory();
      }
    },
    keywordsLocal(keywordsLocal) {
      // 如果没聚焦，不继续执行
      if (!this.isInputFocused) {
        return;
      }
      // 如果聚焦且存在关键词，展示热搜，隐藏历史搜索，否则相反。
      if (keywordsLocal) {
        this.isShowPopupPopularSearch = true;
        this.isShowPopupSearchHistory = false;
      } else {
        this.isShowPopupPopularSearch = false;
        this.isShowPopupSearchHistory = true;
      }
    },
    // 监听是否勾选拓展搜索词
    isExpandSearchKeywordsChecked() {
      this.updateExpandSearchKeywords();
    },
  },
  methods: {
    // 放大镜按钮点击
    handleSearchClick() {
      this.search();
    },
    // 设置拓展搜索词
    updateExpandSearchKeywords() {
      // 权限校验
      if (!authCheck(AUTH_KEY_MAP.SEARCH_KEYWORDS)) return;
      // 拓展词词包匹配
      let expandSearchKeywords = [];
      if (this.keywordsLocal) {
        const keywordsLocalMain = this.keywordsLocal.toLowerCase().split(" ")[0];
        expandSearchKeywords =
          this.expandSearchKeywordsPackages.find((packageArr) => packageArr.includes(keywordsLocalMain)) || [];
      }
      this.expandSearchKeywords = expandSearchKeywords;
      // Vuex 存储命中的 expandSearchKeywords 字符串，供solr使用
      if (expandSearchKeywords.length && this.isExpandSearchKeywordsChecked) {
        this.$store.commit("search/updateExpandSearchKeywordsStr", expandSearchKeywords.join(" "));
      } else {
        this.$store.commit("search/updateExpandSearchKeywordsStr", "");
      }
      /** 埋点 **/
      if (expandSearchKeywords.length) {
        this.$track(DEED_MAP.EXPOSURE, OID_MAP.EXPAND_SEARCH_KEYWORDS_AIMED, {
          ctx: this.keywordsLocal,
        });
        this.$track(DEED_MAP.CLICK, OID_MAP.EXPAND_SEARCH_KEYWORDS_CHECKED, {
          ctx: this.isExpandSearchKeywordsChecked ? 1 : 0,
        });
      }
    },
    // 监听Popular弹窗fetch完成
    handlePopularAndCompanyFetched({ relatedPopularSearch, relatedCompanies }) {
      this.relatedPopularSearch = relatedPopularSearch;
      this.relatedCompanies = relatedCompanies;
      // 得到空数据，隐藏弹窗
      if (relatedPopularSearch.length === 0 && relatedCompanies.length === 0) {
        this.isShowPopupPopularSearch = false;
      }
    },
    // 更多公司
    handleMoreCompanyClick() {
      this.$track(DEED_MAP.CLICK, OID_MAP.MORE_COMPANY_CLICK);
      window.open(`${MORE_COMPANY_URL}?keywords=${this.keywordsLocal}`);
    },
    // 鼠标移过输入框
    handleInputMouseOver(status) {
      // 如果不存在关键词
      if (!this.keywordsLocal) {
        this.handleHistoryMouseOver(status);
      }
    },
    // 清空
    handleSearchInputClear() {
      this.keywordsLocal = "";
      this.$refs.input.focus();
    },
    // 相关热搜点击
    handlePopularSelect({ value }) {
      const { subscribeWordSource } = value;
      this.keywordsLocal = subscribeWordSource;
      this.search();
    },
    // 相关公司点击
    handleCompanySelect({ value }) {
      const { companyName } = value;
      this.keywordsLocal = companyName;
      this.search();
      this.$track(DEED_MAP.CLICK, OID_MAP.RELATED_COMPANY_CLICK, {
        ctx: companyName,
      });
    },
    // 相关搜索 搜索框下方小灰字 点击
    handleRelatedSearchClick(text) {
      this.$track(DEED_MAP.CLICK, OID_MAP.RELATED_SEARCH_CLICK, {
        extendinfo: this.keywordsLocal,
        ctx: text,
      });
      this.keywordsLocal = text;
      this.search();
    },
    // 搜索任务链, 供keywords、currentFilterTab监听改变时用
    updateSearchParamsAndMore() {
      debounce({}, async () => {
        // 更新 本地 keywordsLocal
        this.keywordsLocal = this.$route.query.keywords || "";
        // 更新 本地 filtermode
        this.filterModeLocal =
          (this.$route.query.filtermode && parseInt(this.$route.query.filtermode)) || CLASSIFY_A[0].id;
        // 更新 本地 tabId
        this.tabIdLocal = this.$route.query.tabId || FILTER_TABS[0].id;
        this.$store.commit("search/updateSearchParams", {
          filtermode: this.filterModeLocal,
          keywords: this.keywordsLocal,
          tabId: this.tabIdLocal,
          _t: this.$route.query._t,
        });
        // 更新 本地 store expandSearchKeywords
        this.updateExpandSearchKeywords();
        // 查询相关搜索
        await this.websiteSamejobSearch(this.$route.query.keywords || "");
        // 判断是否命中行业专区
        await this.setIsShowIndustryZone();
      });
    },
    // 改变路由参数 keywords,
    // watch监听到$route.query.keywords变更后执行系列搜索任务
    search() {
      const query = {
        filtermode: this.filterModeLocal,
        keywords: encodeURIComponent(this.keywordsLocal),
        tabId: this.tabIdLocal,
        _t: new Date().getTime(),
      };
      if (this.$route.path !== USER_CENTER_SEARCH_URL) {
        // 非 大搜 open
        let queryStr = "";
        for (const key in query) {
          queryStr += `${key}=${query[key]}&`;
        }
        window.open(USER_CENTER_SEARCH_URL + "?" + queryStr);
      } else {
        // 是 大搜 push
        this.$router
          .push({
            path: USER_CENTER_SEARCH_URL,
            query: {
              ...this.$route.query,
              ...query,
            },
          })
          .catch((e) => e);
      }
      // 关闭弹窗
      setTimeout(() => {
        // 直接关闭弹窗会导致windows 触控板 click失效，故延时
        this.isShowPopupSearchHistory = false;
        this.isShowPopupPopularSearch = false;
      }, 300);
    },
    // 智能订阅弹窗免打扰
    doNotDisturb() {
      const id_list = Cookies.get(CookieKeys.do_not_disturb_smart_subscribe_id_list);
      const industry_zone_id = this.industryZoneData.id;
      return !!(!!id_list && JSON.parse(id_list).includes(industry_zone_id));
    },
    // 判断是否命中行业专区
    async setIsShowIndustryZone() {
      try {
        /** 关闭行业专区 **/
        this.$store.commit("industryZone/updateIsShowIndustryZone", false);
        /** 关闭智能订阅弹窗 **/
        this.$store.commit("industryZone/updateIsShowDialogSmartSubscribe", false);
        /** 展示行业专区 **/
        const res = await restAccountIndustryQueryIsEnter({
          keyword: this.keywordsLocal,
        });
        this.$store.commit("industryZone/updateIndustryZoneData", res.data);
        const { id } = res.data;
        switch (id) {
          case 1:
            this.$store.commit("industryZone/updateIsShowIndustryZone", true);
            break;
          default: {
            if (this.doNotDisturb()) return;
            const smartSubscribeRes = await restAccountIndustryGetBusinessCount({ industryId: id });
            this.$store.commit("industryZone/updateIsShowDialogSmartSubscribe", true);
            this.$store.commit("industryZone/updateSmartSubscribe", smartSubscribeRes.data);
            break;
          }
        }
      } catch (e) {
        /** 不展示行业专区 **/
        this.$store.commit("industryZone/updateIsShowIndustryZone", false);
      }
    },
    // 分类选择
    handleClassifySelect({ value }) {
      // 更新当前分类
      this.filterModeLocal = value.id;
      this.isShowPopupSearchClassify = false;
    },
    // 鼠标移过分类弹窗
    handleClassifyMouseOver(status) {
      if (status === "enter") {
        this.isShowPopupSearchClassify = true;
      }
      if (status === "leave") {
        this.isShowPopupSearchClassify = false;
      }
    },
    // 拉取相关搜索
    async websiteSamejobSearch(keywordsQuery) {
      let relatedSearch = [];
      let peerSearch = [];
      if (keywordsQuery) {
        const res = await websiteKeywordSearchV3({ keyword: keywordsQuery });
        relatedSearch = res.data || [];
        peerSearch = res.data || [];
      }
      // 无keywordsQuery时也需要更新relatedSearch peerSearch
      this.$store.commit("search/updateRelatedSearch", relatedSearch || []);
      this.$store.commit("search/updatePeerSearch", peerSearch || []);
    },
    // 点击换一批按钮
    handleRefreshClick() {
      if (this.relatedSearchRound === 4) {
        this.relatedSearchRound = 0;
        return;
      }
      this.relatedSearchRound++;
      this.$track(DEED_MAP.CLICK, OID_MAP.RELATED_SEARCH_REFRESH);
    },
    // 监听到一次searchParams变更，保存一次搜索历史到localStorage和Vuex store
    setSearchHistory(searchParams, searchChoseParams) {
      if (!searchParams.keywords) return;
      const new_history_obj = {
        label: this.currentFilterTab.label, // todo 找到 searchParams或searchChoseParams里代表label的地方，不用local的
        text: searchParams.keywords,
        searchParams,
        searchChoseParams,
      };
      let search_history = deepClone(this.searchHistory);
      // 避免重复
      const search_history_filtered = search_history.filter((value) => value.text !== new_history_obj.text);
      search_history_filtered.unshift(new_history_obj);
      // 截取最新的8个历史
      search_history = search_history_filtered.slice(0, 8);
      // 保存
      localStorage.setItem(LOCAL_STORAGE_KEY_MAP.SEARCH_HISTORY, JSON.stringify(search_history));
      this.$store.commit("search/updateSearchHistory", search_history);
    },
    // 历史弹窗展开时，从localStorage读取搜索历史保存进Vuex store
    readingSearchHistory() {
      /**
       * 老大搜历史记录解析
       * todo 新大搜上线后删除
       * **/
      /** start **/
      this.askSearchHistoryFromOldSearchOrigin();
      let old_search_history = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY));
      // 判断类型
      if (!old_search_history || old_search_history.constructor !== Array) {
        old_search_history = [];
      }
      old_search_history = old_search_history.reduce((prev, cur) => {
        /** 从老历史的url中解构出query(searchParams) **/
        let {
          areas: oldAreas,
          allType: oldAllType,
          purchasingUnitIdList: oldPurchasingUnitIdList,
          timeType: oldTimeType,
        } = getQuery(cur.url);
        /** 地区 **/
        const newAreas = {};
        if (oldAreas) {
          newAreas.key = "newAreas";
          newAreas.id = decodeURIComponent(oldAreas);
          newAreas.tmpl = [];
          const oldAreasArr = decodeURIComponent(oldAreas).split(",");
          for (let i = 0; i < oldAreasArr.length; i++) {
            const item = getAreaJson().find((v) => v.id === parseInt(oldAreasArr[i]));
            newAreas.tmpl.push(item);
          }
        }

        /** 信息类型 **/
        const allType = {};
        if (oldAllType) {
          allType.key = "allType";
          allType.id = parseInt(oldAllType);
          allType.text = TYPE_ALL.find((v) => v.id === parseInt(oldAllType)).text;
        }

        /** 采购单位 **/
        const purchasingUnitIdList = {};
        if (oldPurchasingUnitIdList) {
          purchasingUnitIdList.key = "purchasingUnitIdList";
          purchasingUnitIdList.id = decodeURIComponent(oldPurchasingUnitIdList);
          purchasingUnitIdList.tmpl = [];
          const oldPurchasingUnitIdListArr = decodeURIComponent(oldPurchasingUnitIdList).split(",");
          for (let i = 0; i < oldPurchasingUnitIdListArr.length; i++) {
            const item = DICTIONARY.PURCHASING_UNIT.find((v) => v.id === parseInt(oldPurchasingUnitIdListArr[i]));
            purchasingUnitIdList.tmpl.push(item);
          }
        }

        /** 时间 **/
        const timeType = {};
        if (oldTimeType) {
          timeType.key = "timeType";
          timeType.id = parseInt(oldTimeType);
          timeType.text = TIME_LIST.find((v) => v.id === parseInt(oldTimeType)).text;
        }

        /** 搜索历史项 老 => 新 重组 **/
        const old_search_history_item = {
          label: cur.tag,
          searchChoseParams: {
            newAreas, // 地区
            allType, // 信息类型
            purchasingUnitIdList, // 采购单位
            timeType, // 时间
          },
          searchParams: {},
          text: cur.keywords,
          url: cur.url, // 老大搜特有
        };
        prev.push(old_search_history_item);
        return prev;
      }, []);
      /** end **/

      /** 新搜索历史记录解析 **/
      let search_history = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_MAP.SEARCH_HISTORY));
      // 判断类型
      if (!search_history || search_history.constructor !== Array) {
        search_history = [];
      }
      // todo 新大搜上线后恢复
      // this.$store.commit("search/updateSearchHistory", search_history);
      // todo 新大搜上线后删除
      this.$store.commit("search/updateSearchHistory", old_search_history.concat(search_history).slice(0, 8));
    },
    // todo 新大搜上线后删除
    getSearchHistoryFromOldSearchOrigin() {
      if (this.eventListenerAdded) return;
      window.addEventListener("message", (e) => {
        this.eventListenerAdded = true;
        const { key, value } = e.data;
        if (key === LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY) {
          localStorage.setItem(LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY, value);
        }
      });
    },
    // todo 新大搜上线后删除
    askSearchHistoryFromOldSearchOrigin() {
      let iframe = document.querySelector("#iframe_old_search");
      if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.id = "iframe_old_search";
        iframe.style.display = "none";
        iframe.src = process.env.VUE_APP_OLD_SEARCH_URL + "/apostMassge.html";
        iframe.style.width = 0;
        iframe.style.height = 0;
        iframe.frameBorder = 0;
        document.body.appendChild(iframe);
      } else {
        // 向searchOrigin发起请求，询问最新的localStorage['historyItemsNew']
        // 又因为getSearchHistoryFromOldSearchOrigin为异步操作，
        // 故当次ask的localStorage下一次打开弹窗时才可渲染
        iframe.contentWindow.postMessage(
          JSON.stringify({
            type: "GET",
            key: LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY,
          }),
          "*"
        );
      }
    },
    // 历史搜索记录 点击
    handleHistorySelect({ value }) {
      /** todo 老大搜url 新大搜上线后删除 **/
      if (value.url) return window.open(value.url);
      /** todo end **/
      const { text, label, searchParams, searchChoseParams } = value;
      this.keywordsLocal = text;
      this.tabIdLocal = FILTER_TABS.find((v) => v.label === label).id;
      this.$store.commit("search/updateSearchParams", searchParams);
      this.$store.commit("search/updateSearchChoseParams", searchChoseParams);
      this.search();
      this.$track(DEED_MAP.CLICK, OID_MAP.SEARCH_HISTORY_CLICK, {
        ctx: value.text,
      });
    },
    // 历史搜索记录 删除一条
    handleHistoryDelete({ index }) {
      const newSearchHistory = this.searchHistory.reduce((prev, cur, i) => {
        index !== i && prev.push(cur);
        return prev;
      }, []);
      this.$store.commit("search/updateSearchHistory", newSearchHistory);
      // todo 新大搜上线后恢复
      // localStorage.setItem(
      //   LOCAL_STORAGE_KEY_MAP.SEARCH_HISTORY,
      //   JSON.stringify(newSearchHistory)
      // );
      // todo end

      // todo 新大搜上线后删除
      /** 修改老大搜历史记录 **/
      let old_search_history = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY)).reduce(
        (prev, cur, i) => {
          index !== i && prev.push(cur);
          return prev;
        },
        []
      );
      // 修改本域
      localStorage.setItem(LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY, JSON.stringify(old_search_history));
      // 修改搜索域
      let iframe = document.querySelector("#iframe_old_search");
      iframe.contentWindow.postMessage(
        JSON.stringify({
          type: "SET",
          key: LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY,
          value: JSON.stringify(old_search_history),
        }),
        "*"
      );
      // todo end
    },
    // 清空搜索历史
    handleHistoryClear() {
      this.$store.commit("search/updateSearchHistory", []);
      // todo 新大搜上线后恢复
      // localStorage.setItem(
      //   LOCAL_STORAGE_KEY_MAP.SEARCH_HISTORY,
      //   JSON.stringify([])
      // );
      // todo end

      // todo 新大搜上线后删除
      /** 修改老大搜历史记录 **/
      let old_search_history = [];
      // 修改本域
      localStorage.setItem(LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY, JSON.stringify(old_search_history));
      // 修改搜索域
      let iframe = document.querySelector("#iframe_old_search");
      iframe.contentWindow.postMessage(
        JSON.stringify({
          type: "SET",
          key: LOCAL_STORAGE_KEY_MAP.OLD_SEARCH_HISTORY,
          value: JSON.stringify(old_search_history),
        }),
        "*"
      );
      // todo end
    },
    // 鼠标移过历史弹窗
    handleHistoryMouseOver(status) {
      if (status === "enter") {
        this.isShowPopupSearchHistory = true;
      }
      if (status === "leave") {
        this.isShowPopupSearchHistory = false;
      }
    },
  },
  // todo 新大搜上线后删除
  mounted() {
    this.getSearchHistoryFromOldSearchOrigin();
  },
};
</script>

<style lang="scss">
.expand_key_words {
  .checkbox {
    .el-checkbox__input {
      margin-top: 3px;
      z-index: 0;
    }

    .el-checkbox__label {
      padding-left: 5px;
      line-height: 14px;
      font-size: 12px;
      color: #333 !important;
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../../assets/config";

.search-bar {
  height: 100%;
  width: 500px;
  margin: 0 auto;

  .search_input_container {
    margin-top: 20px;

    width: 100%;
    height: 40px;
    background-color: white;
    border-color: $theme-color;
    border-width: 1px;
    border-style: solid;
    border-radius: 20px;

    display: flex;
    align-items: center;

    position: relative;

    .search_input_container_left {
      width: fit-content;
      height: 100%;

      padding-left: 18px;
      padding-right: 26px;

      position: relative;

      font-size: 14px;
      color: black;
      cursor: pointer;
      display: flex;
      align-items: center;

      .icon_new {
        width: 24px;
        height: 12px;
        position: absolute;
        top: 1px;
        right: 0;
      }

      i {
        width: fit-content;
        height: 12px;
        line-height: 12px;
        color: #bfbfbf;
        font-size: 12px;

        position: absolute;
        top: 13px;
        right: 7px;
        transition: all 0.2s linear;
      }

      .rotate {
        color: $theme-color;
        transform: rotate(180deg);
      }
    }

    .search_input_container_center {
      height: 100%;
      flex: 1;
      margin: 0 2px;
      padding-right: 8px;

      display: flex;
      align-items: center;

      input {
        color: black;
        border-left: 1px #cccccc solid;
        width: 100%;
        height: 20px;
        padding-left: 13px;
      }

      i {
        font-size: 14px;
        color: #d1cfcf;
        cursor: pointer;
      }
    }

    .search_input_container_right {
      height: 100%;
      background-color: $theme-color;
      display: flex;
      align-items: center;
      padding: 0 30px 0 30px;

      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      cursor: pointer;

      i {
        font-size: 20px;
        color: white;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .expand_key_words {
    font-size: 12px;
    line-height: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-left: 20px;

    .words_container {
      max-width: 333px;
      //单行
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;

      .words {
        color: #666;
        padding: 0 2px;
      }

      &:hover {
        white-space: nowrap;
        overflow: visible;
      }
    }
  }

  .related_key_words {
    color: #999999;
    font-size: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    margin-top: 12px;
    position: relative;
    z-index: 1;

    &:hover {
      .words_container {
        max-width: fit-content;
        white-space: nowrap;
        overflow: visible;
      }
    }

    .title {
      white-space: nowrap;
      width: 60px;
    }

    .words_container {
      max-width: 365px;
      //单行
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    .words {
      color: #7c7d81;
      border-left: 1px solid #cccccc;
      padding: 0 10px;
      cursor: pointer;

      &:first-child {
        border: none;
        padding-left: 0;
      }

      &:hover {
        color: $theme-color;
      }
    }

    .refresh {
      cursor: pointer;
      color: $theme-font-color;
    }

    .default_related_search {
      display: flex;
      padding-left: 20px;
    }

    .tips {
      width: 120px;
      overflow: hidden;
      white-space: nowrap;
      margin-left: 20px;
      color: $theme-color;

      .scroll {
        animation: scroll 10s linear infinite;
      }

      @keyframes scroll {
        from {
          margin-left: 120px;
        }
        to {
          margin-left: -360px;
        }
      }
    }
  }
}
</style>
<!-- 根据是否显示行业专区更换皮肤 -->
<style scoped lang="scss" src="./SearchBar_IndustryZone.scss"></style>
